(ns app.components.folder-items.drag-drop
  (:require-macros
   [re-com.core  :refer [handler-fn]])
  (:require [re-com.core :as re-com :refer [at h-box]]
            [reagent.core   :as    reagent]))

(def drag-drop (atom {}))

(defn subvector [start stop list] ;start included and stop non included
  (take (- stop start) (drop start list)))

(defn change-list [start-index stop-index list]
  (let [go-up (> start-index stop-index)
        min (min start-index stop-index)
        max (max start-index stop-index)
        list-item (nth list start-index)
        start-list (vec (take min list))
        end-list (vec (subvector (+ max 1) (count list) list))
        middle-list (vec (if go-up (subvector min max list) (subvector (+ min 1) (+ max 1) list)))]
    (if go-up
      (concat start-list [list-item] middle-list end-list)
      (concat start-list middle-list [list-item] end-list))))

(defn index-element-drop [y-drop list-y-offset list-height first-element-index]
  (let [y-drop-minus-offset (- y-drop list-y-offset)
        index (quot y-drop-minus-offset list-height)]
    (+ index first-element-index)))

(defn not-in-box [x-end-drop y-end-drop list-rectangle]
  (or (> (.-left list-rectangle) x-end-drop)
      (< (.-right list-rectangle) x-end-drop)
      (> (.-top list-rectangle) y-end-drop)
      (< (.-bottom list-rectangle) y-end-drop)))

(defn should-abort-drop [start-index stop-index x-end-drop y-end-drop list-rectangle]
  (or (= start-index stop-index)
      (not-in-box x-end-drop y-end-drop list-rectangle)))

(defn start-drop [index]
  (let [list-element (first (js->clj (.getElementsByClassName js/document "draggable-list")))
        first-element-index (int (.getAttribute list-element "idList"))
        rectangle-first-list-item (.getBoundingClientRect list-element)
        visible-list-element (first (js->clj (.getElementsByClassName js/document "drag-drop-folder-container")))
        rectangle-visible-list (.getBoundingClientRect visible-list-element)]
    (swap! drag-drop assoc
           :start-index index
           :first-element-index first-element-index
           :list-y-offset (.-top rectangle-first-list-item)
           :visible-rectangle rectangle-visible-list)))

(defn css-go-up [start-index current-index item-index class-list]
  (prn "DOM UP")
  (prn (str "item>>" item-index))
  (prn current-index)
  (when
   (>= item-index start-index)
    (.add class-list "down")))

(defn css-go-down [start-index current-index item-index class-list]
  (prn "DOM DOWN")
  ;; (prn start-index)
  (prn (str "item>>" item-index))

  (prn current-index)
  ;; (prn item-index)
  (when
   (<= item-index current-index)
    (.add class-list "up")))

(defn css-dom [item start-index current-index]
  (let [item-index (int (.getAttribute item "idList"))
        class-list (.-classList item)
        ;go-up (> start-index current-index)
        go-up (= (:going-up @drag-drop) "UP")]
    (when (= item-index start-index)
      (set! (.. item -style -opacity) 0))
    (if go-up
      (css-go-up start-index current-index item-index class-list)
      (css-go-down start-index current-index item-index class-list))))

(defn css-dom-reset [item]
  (let [class-list (.-classList item)]
    (.remove class-list "down")
    (set! (.. item -style -opacity) 1)))

(defn set-going-up [current-index  last-current-index]
  ;; (prn current-index)
  ;; (prn last-current-index)
  (when (not= current-index last-current-index)
    (prn "NOT EQ")
    (let [going-up? (< current-index last-current-index)
          old-going-up (:going-up @drag-drop)
          new-going-up (if going-up? "UP" "DOWN")]
      (when (not= old-going-up new-going-up)
        (let [list-elements (js->clj (.getElementsByClassName js/document "draggable-list"))
              length (.-length list-elements)]
          ;(swap! drag-drop assoc :start-index current-index)
          (doseq [el (range length)]
            (css-dom-reset (.item list-elements el)))))
      (swap! drag-drop assoc :last-current-index current-index :going-up new-going-up))))

(defn drag-in-progress [x y]
  (prn "IN PROGRESS")
  (prn (:going-up @drag-drop))
  (when (= (:last-current-index @drag-drop) nil)
    (swap! drag-drop assoc :last-current-index (index-element-drop y (:list-y-offset @drag-drop) 44 (:first-element-index @drag-drop))))
  (let [start-index (:start-index @drag-drop)
        current-index (index-element-drop y (:list-y-offset @drag-drop) 44 (:first-element-index @drag-drop))
        last-current-index (:last-current-index @drag-drop)
        list-elements (js->clj (.getElementsByClassName js/document "draggable-list"))
        length (.-length list-elements)]
    (set-going-up current-index  last-current-index)
    (if (not-in-box x y (:visible-rectangle @drag-drop))
      (doseq [el (range length)]
        (css-dom-reset (.item list-elements el)))
      (doseq [el (range length)]
        (when-not (= start-index current-index)
          (css-dom (.item list-elements el) start-index current-index))))))

(defn end-drop [x-end-drop y-end-drop original-list]
  (let [start-index (:start-index @drag-drop)
        stop-index (index-element-drop y-end-drop (:list-y-offset @drag-drop) 44 (:first-element-index @drag-drop))
        list-elements (js->clj (.getElementsByClassName js/document "draggable-list"))
        length (.-length list-elements)]
    (swap! drag-drop assoc :going-up nil :last-current-index nil)
    (doseq [el (range length)]
      (css-dom-reset (.item list-elements el)))
    (if (should-abort-drop start-index stop-index x-end-drop y-end-drop (:visible-rectangle @drag-drop))
      original-list
      (change-list start-index stop-index original-list))))

;; (defn drag-end [result workspace-folders]
;;   (when-not(or (.-destination result)result)
;;     js/undefined)

;;   )